import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          insertion: {
            '{}': {
              inputs: {
                '{}': {
                  records: {
                    '[]': [
                      {
                        '{}': {
                          values: {
                            '{}': {
                              '!id': {
                                '@$': 'proposalId',
                              },
                              '!org': {
                                '@$': 'proposalOrganization',
                              },
                              '!code': {
                                '@$': 'proposalCode',
                              },
                              '!name': {
                                '@$': 'proposalName',
                              },
                              '!amount': {
                                '@$': 'proposalAmount',
                              },
                              '!client': {
                                '@$': 'proposalClient',
                              },
                              '!status': {
                                '@$': 'proposalStatus',
                              },
                              '!due_date': {
                                '@$': 'proposalDueDate',
                              },
                              '!org_offering': {
                                '@$': 'proposalOrgOffering',
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              modelId: 'ent:!proposals:!proposal',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
